import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import CampaignIcon from '@mui/icons-material/Campaign';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import GroupIcon from '@mui/icons-material/Group';
import GroupsIcon from '@mui/icons-material/Groups';
import BlockIcon from '@mui/icons-material/Block';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
import { useIsBrand } from 'root/src/client/v2/auth/hooks/useIsBrand';
import { SettingsLinkRow } from './SettingsLinkRow';
import { SettingsDialogRow } from './SettingsDialogRow';
import { PublisherSettingsSection } from './PublisherSettingsSection';
import { NotificationSettingsSection } from './NotificationSettingsSection';
export const PublisherPanel = () => {
    const { isBrand, isBrandAdmin } = useIsBrand();
    const canSeeBanList = isBrand || isBrandAdmin;
    return (<div>
			<h3 className="mb-1 text-sm font-semibold">Publisher</h3>
			<p className="mb-4 text-xs text-muted-foreground">Manage your settings, campaigns, products, and creators.</p>
			<div className="space-y-2">
				<SettingsDialogRow label="Publisher Settings" description="Brand profile and preferences" Icon={SettingsIcon} title="Publisher Settings">
					<PublisherSettingsSection />
				</SettingsDialogRow>
				<SettingsDialogRow label="Notification Settings" description="Email and alert preferences" Icon={NotificationsIcon} title="Notification Settings">
					<NotificationSettingsSection />
				</SettingsDialogRow>
				<SettingsLinkRow label="Campaigns" description="Track and manage your campaigns" href="/nova/campaigns" Icon={CampaignIcon}/>
				<SettingsLinkRow label="Add Campaign" description="Create a new campaign" href={routeUrls.addCampaignRedesign()} Icon={AddCircleOutlineIcon}/>
				<SettingsLinkRow label="Brand Dares" description="Track your dares, pledges, and videos" href="/nova/publisher-dares" Icon={EmojiEventsIcon}/>
				<SettingsLinkRow label="Approve Dares" description="Review and approve dare deliveries" href="/nova/brand-approve-dares" Icon={FactCheckOutlinedIcon}/>
				<SettingsLinkRow label="Keys & Products" description="Manage reward keys and products" href="/nova/keys-and-products" Icon={VpnKeyIcon}/>
				<SettingsLinkRow label="Brand Users" description="Invite teammates and manage roles" href="/nova/brand-users" Icon={GroupsIcon}/>
				<SettingsLinkRow label="Whitelisted Creators" description="Creators allowed to participate" href="/nova/whitelisted-creators" Icon={GroupIcon}/>
				{canSeeBanList && (<SettingsLinkRow label="Banned Creators" description="Creators blocked from your campaigns" href="/nova/banned-creators" Icon={BlockIcon}/>)}
				<SettingsLinkRow label="My applications" description="Your campaign applications" href={routeUrls.applicationsRedesign()} Icon={AssignmentIcon}/>
			</div>
		</div>);
};
